import { render, staticRenderFns } from "./SideBarInfo.vue?vue&type=template&id=60bc5657&scoped=true&"
import script from "./SideBarInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarInfo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bc5657",
  null
  
)

export default component.exports